export const formatDate = (dateString) => {
    const date = new Date(dateString);  
    const options = { month: 'long', day: '2-digit', year: 'numeric' };
    return date.toLocaleDateString('en-US', options); 
};
  
export const formatTime = (timeString) => {
    if (!timeString) return '-';
    const date = new Date(`1970-01-01T${timeString}`);
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return date.toLocaleTimeString('en-US', options);
};

export const formatCurrency = (price) => {
    return '$' +price;
};
export const getErrorMessage = (errorOrResponse, defaultMessage = "Something went wrong") => {
    try {
        // If it's an axios error object
        const data = errorOrResponse?.response?.data || errorOrResponse;

        // If has `message` field directly
        if (typeof data?.message === 'string' && data.message.trim()) {
            return data.message;
        }

        // If message is an object like { gender: ["..."] }
        if (typeof data?.message === 'object' && data.message !== null) {
            const firstKey = Object.keys(data.message)[0];
            if (Array.isArray(data.message[firstKey]) && data.message[firstKey][0]) {
                return data.message[firstKey][0];
            }
        }

        // If has `errors` object with arrays of messages
        if (data?.errors && typeof data.errors === 'object') {
            const firstErrorKey = Object.keys(data.errors)[0];
            if (Array.isArray(data.errors[firstErrorKey]) && data.errors[firstErrorKey][0]) {
                return data.errors[firstErrorKey][0];
            }
        }

        // If it's like { status: ["Status must be a valid value."] }
        if (typeof data === 'object') {
            const firstKey = Object.keys(data)[0];
            if (Array.isArray(data[firstKey]) && data[firstKey][0]) {
                return data[firstKey][0];
            }
        }

        // Native JS error fallback
        if (errorOrResponse?.message) {
            return errorOrResponse.message;
        }

        return defaultMessage;
    } catch {
        return defaultMessage;
    }
};


export const getErrorMessagesList = (errorOrResponse, defaultMessage = ["Something went wrong"]) => {
    let list = [];

    try {
        const data = errorOrResponse?.response?.data || errorOrResponse;
        const extract = (msgObj) => {
            Object.keys(msgObj).forEach((key) => {
                const Title = key
                    .replace(/_/g, " ")         // payment_token → payment token
                    .replace(/\b\w/g, c => c.toUpperCase()); // capitalize every word

                if (Array.isArray(msgObj[key])) {
                    msgObj[key].forEach(err => {
                        list.push(`${Title}: ${err}`);
                    });
                }
            });
        };

        // CASE 1 → string message
        if (typeof data?.message === "string") {
            return [data.message];
        }

        // CASE 2 → { message: { field: [errors] } }
        if (typeof data?.message === "object" && data.message !== null) {
            extract(data.message);
            return list.length ? list : defaultMessage;
        }

        // CASE 3 → "errors" object (Laravel style)
        if (data?.errors && typeof data.errors === "object") {
            extract(data.errors);
            return list.length ? list : defaultMessage;
        }

        // CASE 4 → raw object { field: ["error"] }
        if (typeof data === "object") {
            extract(data);
            return list.length ? list : defaultMessage;
        }

        // CASE 5 → JS Error fallback
        if (errorOrResponse?.message) {
            return [errorOrResponse.message];
        }

        return defaultMessage;

    } catch {
        return defaultMessage;
    }
};
